module.exports = __webpack_public_path__ + "static/media/ic_hs_cover_amount.ac15a7d2.svg";